import { PropsWithChildren, ReactNode } from "react";

import classNames from "classnames/bind";
import { Plus } from "@fsg/icons";
import { ButtonV2 } from "@fsg/gui-bits";
import moduleStyles from "./Form.module.scss";
const cx = classNames.bind(moduleStyles);

interface FormSectionProps extends PropsWithChildren {
  title?: ReactNode;
  action?: ReactNode;
}

export function FormSection({ title, children, action }: FormSectionProps) {
  return (
    <div className={cx("m--form-subgrid-item", "bg-white rounded-md relative")}>
      <div className="px-4 pt-4">
        {title && (
          <div className="flex justify-between items-center mb-4">
            {title}
            {action && <div className="flex items-center">{action}</div>}
          </div>
        )}
        <div className={cx("m--flex-col", "pb-4")}>{children}</div>
      </div>
    </div>
  );
}

interface AddButtonProps {
  onClick: () => void;
}

export function AddButton({ onClick }: AddButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-[28px] h-[28px] items-center justify-center rounded-[var(--2XS,6px)] bg-[var(--bg-grey-200)] p-[6px] hover:bg-gray-300 text-gray-600 self-center"
    >
      <Plus className="h-4 w-4" />
    </button>
  );
}
